import axios from "axios";
import {SALESBOX_API_URL} from "@/common/config";
import { locales } from '@/common/localesList'

const initialState = {
    currentStep: 0,
    steps: [],
    vueTourOn: false

};

export const state = { ...initialState };

export default {
    namespaced: true,
    state,
    mutations: {
        reset (state) {
            const s = initialState;
            Object.keys(s).forEach(key => state[key] = s[key])
        },
        setSteps(state, value) {
            state.steps = value;
        },
        setCurrentStep(state, value) {
            state.currentStep = value;
        },
        setVueTourOn(state, value) {
            state.vueTourOn = value;
        },
    },
    actions: {
        async fetchScript(context, payload){

                await axios.get(`${SALESBOX_API_URL}script/${payload.locale}/${payload.id}`).then(async (response) => {
                    let steps = response.data.steps
                    context.commit('setSteps', steps);
                })

            // const steps = [
            //     {
            //         target: '[data-v-step="0"]',
            //         header: {
            //             title: "NEW !"
            //         },
            //         content: {
            //             title: 'Ut enim ad minima veniam 1',
            //             text: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur Nemo enim ipsam voluptatem quia voluptas sit aspernatur'
            //         },
            //     },
            //
            //     {
            //         target: '[data-v-step="1"]',
            //         header: {
            //             title: "NEW !"
            //         },
            //         content: {
            //             title: 'Ut enim ad minima veniam 2',
            //             text: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur Nemo enim ipsam voluptatem quia voluptas sit aspernatur'
            //         },
            //     },
            //     {
            //         target: '[data-v-step="2"]',
            //         header: {
            //             title: "NEW !"
            //         },
            //         content: {
            //             title: 'Ut enim ad minima veniam 3',
            //             text: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur Nemo enim ipsam voluptatem quia voluptas sit aspernatur'
            //         },
            //         route: {name: 'search-machines'}
            //     },
            // ];
            //context.commit('setSteps', steps);

        }
    }
};
